<template>
  <input
    type="tel"
    :id="id"
    :name="name"
    :value="numberValue"
    class="c-input-code"
    :class="{
      'c-input-code--error': error
    }"
    :error="error"
    @keyup="validateValue"
    @input="updateValue"
    @focus="focus"
    ref="code"
  />
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    error: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      numberValue: this.value
    };
  },
  methods: {
    updateValue(e) {
      this.numberValue = e.target.value ? e.target.value : "";
    },
    validateValue(e) {
      e = e || window.event;
      let key = e.keyCode || e.which;
      key = String.fromCharCode(key);

      const regex = /[0-9]/;
      if (!regex.test(key)) {
        e.returnValue = false;
        if (e.preventDefault) e.preventDefault();
      }
      this.$emit("keypress", e);
    },
    focus(e) {
      this.$emit("focus", e);
      this.$refs.code.select();
    },
    selfFocus(e) {
      this.$refs.code.focus();
    }
  },
  watch: {
    numberValue(newValue, oldValue) {
      let value = String(newValue);
      if (String(newValue).length > 1) {
        value = value.replace(oldValue, "");
      }
      this.numberValue = value;
      this.$emit("input", value);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-input-code {
  font-size: rem(14);
  text-align: center;
  line-height: normal;
  width: 100%;
  border: px(1) solid $common-gray-border;
  border-radius: px(4);
  padding: rem(10) rem(12) rem(11) rem(12);
  display: block;

  &--error {
    border-color: $error;
  }

  &--has_icon {
    padding-right: px(48+12);
  }

  &--has_suffix {
    padding-right: px(24+12);
  }

  &::placeholder {
    color: $common-gray300;
  }

  &:focus {
    border-color: $common-black;
  }
}
</style>
